import WebViewReload from './WebViewReload';

export default WebViewReload;
